/**
 * Matcher for language
 * @module
 */

exports.fieldsNeeded = ['language'];

/**
 *
 * @param {Object} value
 * @param {string} [value.language]
 * @param {Condition} cond
 * @returns {boolean}
 */
exports.match = function(value:any, cond:Condition): boolean {
  if (!value.language) {
    return false;
  }
  return value.language.toLowerCase().indexOf(cond.value) > -1;
};
